/*@flow*/
import React from 'react';
import * as vl from 'vega-lite';
import Vega from '../Vega';
import type { Props } from './';
import hash from 'lib/hash';

class VegaLite extends React.Component<Props<>> {
  shouldComponentUpdate(np: Props<>) {
    return hash(np.data) !== hash(this.props.data);
  }
  render() {
    const props = this.props;
    const parsedProps = { ...props };
    const combinedSpec = { ...props.spec };
    if (props.data) {
      combinedSpec.data = props.data;
      delete parsedProps.data;
    }
    parsedProps.spec = vl.compile(combinedSpec).spec;
    return <Vega {...parsedProps} />;
  }
}

export default VegaLite;
